import { render } from "./HomeModalDeleteAlbum.vue?vue&type=template&id=742c954b"
import script from "./HomeModalDeleteAlbum.vue?vue&type=script&lang=js"
export * from "./HomeModalDeleteAlbum.vue?vue&type=script&lang=js"
script.render = render

export default script